import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/press_marketing.png";
import aquaflow_graph from "../assets/marketing/press_marketing2.png";

const Bomba = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>MAIS PRESSÃO EM TODOS OS PONTOS DE ÁGUA</h3>
          <p>
            Garante fluxo constante e forte em chuveiros, torneiras e máquinas,
            eliminando a baixa pressão e proporcionando mais conforto no uso
            diário.
          </p>
        </div>
        <div>
          <h3>FUNCIONAMENTO AUTOMÁTICO E SILENCIOSO</h3>
          <p>
            Ativa somente quando há consumo de água, oferecendo eficiência,
            economia de energia e operação silenciosa, ideal para uso
            residencial.
          </p>
        </div>
        <div>
          <h3>DURABILIDADE E SEGURANÇA</h3>
          <p>
            Construído com materiais resistentes à corrosão e preparado para
            altas temperaturas, assegura longa vida útil e desempenho confiável.
          </p>
        </div>
      </div>

      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"pressurizador"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Bomba;
